import React, { useState } from "react";
import { TextField, Button, Grid, Box, Typography } from "@mui/material";
import axios from "axios";
import "../ComponentCss/Register.css";

const RegistrationForm = () => {
  const [formValues, setFormValues] = useState({
    firstName: "",
    lastName: "",
    email: "",
    address: "",
    companyDomain: "",
    companyName: "",
    companyEmail: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };



  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        "https://wkb0n6m2yk.execute-api.ap-south-1.amazonaws.com/Prod/api/users/register",
        {
          FirstName: formValues.firstName,
          LastName: formValues.lastName,
          email: formValues.email,
          Address: formValues.address,
          CompanyName: formValues.companyName,
          CompanyDomain: formValues.companyDomain,
          CompanyEmail: formValues.companyEmail,
        }
      );
      console.log("Form submitted:", response.data);
      alert("Company registered successfully!");
    } catch (err) {
      console.error("Error registering company:", err);
      alert("Failed to register company.");
    }
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{
        mt: 5,
        width: "100%",
        maxWidth: 400,
        mx: "auto",
        p: 3,
        bgcolor: "#bbe06c",
        borderRadius: 2,
      }}
    >
      <Typography variant="h5" align="center" gutterBottom>
        Register
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <input
            className="register-input"
            type="text"
            name="firstName"
            placeholder="First Name"
            value={formValues.firstName}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <input
            className="register-input"
            type="text"
            name="lastName"
            placeholder="Last Name"
            value={formValues.lastName}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12}>
          <input
            className="register-input"
            type="email"
            name="email"
            placeholder="Email"
            value={formValues.email}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12}>
          <input
            className="register-input"
            type="text"
            name="address"
            placeholder="Address"
            value={formValues.address}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12}>
          <input
            className="register-input"
            type="text"
            name="companyDomain"
            placeholder="Company Domain"
            value={formValues.companyDomain}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12}>
          <input
            className="register-input"
            type="text"
            name="companyName"
            placeholder="Company Name"
            value={formValues.companyName}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12}>
          <input
            className="register-input"
            type="text"
            name="companyEmail"
            placeholder="Company Email"
            value={formValues.companyEmail}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12}>
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{
              backgroundColor: "#4caf50", // Custom green color
              "&:hover": {
                backgroundColor: "#388e3c", // Darker shade for hover effect
              },
            }}
          >
            Register
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default RegistrationForm;
